import { Card, Badge, theme } from "antd"
import React, { useCallback, useEffect, useState } from "react"
import ImgIcon from "../../../../view/img-icon"
import { EnquireRowDetailItem } from "./enquire-row-detail-item.component";
import { EnquiryRes } from "../../../../response/enquiry.response";
import { useEnquiry } from "../../enquiry.hook";
import InfiniteScroll from "react-infinite-scroll-component";

export interface EnquiryGridDetailProp {
    enquiryList: EnquiryRes[]
}

export const EnquiryGridDetail: React.FC<EnquiryGridDetailProp> = ({ enquiryList }) => {

    const [pageNumber, setPageNumber] = useState(1)

    const { useToken } = theme;
    const { token } = useToken();

    const getIcon = (status: string) => {
        switch (status) {
            case "Pending":
                return "open.svg"
            case "Closed":
                return "close.svg"
            case "In Progress":
                return "inprogress.svg"
            case "Not Interested":
                return "rejected.svg"
            case "Dump / Spam":
                return "rejected.svg"
        }

        return "inprogress.svg"
    }

    const { fetchEnquiryList, enquirySearchReq, updateLoading, statusList } = useEnquiry()

    const onLeadSuccess = useCallback(async () => {
        fetchEnquiryList({ ...enquirySearchReq, pageNumber: 1 }, () => { updateLoading(false) }, () => { updateLoading(false) })
    }, [])

    const getColumnView = React.useMemo(() => {
        return <InfiniteScroll
            dataLength={pageNumber * 10}
            next={() => {
                setPageNumber(prevPage => prevPage + 1);
            }}
            hasMore={pageNumber * 10 < enquiryList.length}
            loader={<h4>Loading...</h4>}
        >
            {enquiryList.slice(0, Math.min(pageNumber * 10, enquiryList.length)).map((enquiry: EnquiryRes, index: number) => {
                return <EnquireRowDetailItem enquiry={enquiry} lastItem={index == enquiryList.length - 1} onLeadSuccess={onLeadSuccess} statusList={statusList} />
            })}
        </InfiniteScroll>
    }, [enquiryList, pageNumber])

    return (
        <React.Fragment>

            <Card bodyStyle={{
                padding: 10
            }}>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: '#E0EEF7',
                    color: '#343433',
                    padding: '6px 10px',
                    borderRadius: token.borderRadius,
                    marginBottom: 8
                }}>
                    {enquiryList.length > 0 && <>
                        <ImgIcon iconName={getIcon(enquiryList[0].status.value)} iconWidth="16px" />
                        <span>{enquiryList[0].status.value}</span>
                    </>}
                    <Badge count={enquiryList.length} style={{
                        background: '#6D6C68',
                        padding: '0 4px',
                        boxShadow: 'none',
                        margin: '0 6px'
                    }}
                        overflowCount={9999} />
                </div>
                {
                    getColumnView
                }

            </Card>
        </React.Fragment>
    )
}